import React, { Component } from 'react'
import Link from '../utils/link'

class Guides extends Component {

  state = {
    items: false,
  }

  componentDidMount() {
    this._showCategory(0)
  }

  _showCategory = (key) => {
    let items = [];
    items[key] = true
    this.setState({ items })
  }

  render() {

    let { title, categories } = this.props
    let { items } = this.state

    return (
      <section className='guides'>
        <div className='guides__inner'>
          <div className='guides__title'>
            <h3>{title}</h3>
            { categories && 
              <ul className='guides__list'>
                { categories.map((el, i) => (
                  <li className={`guides__list-item ${items[i] ? 'active' : ''}`} key={i}>
                    <button type='button' onClick={() => this._showCategory(i)}>{el.title}</button>
                  </li>
                ))}
              </ul>
            }
          </div>
          <div className='guides__content'>
            { categories && 
              <div className='guides__categories'>
                { categories.map((el, i) => (
                  <div className={`guides__category ${items[i] ? 'active' : ''}`} key={i}>
                    { el.items.map((guide, g) => (
                      <div className='guides__item' key={g}>
                        { guide.image?.sourceUrl && <img src={guide.image.sourceUrl} alt={title} /> }
                        <span className='guides__item-category'>{el.title}</span>
                        <div className='guides__item-title'>
                          <span>{guide.title}</span>
                        </div>
                        { guide.pdf?.sourceUrl && <Link to={guide.pdf.sourceUrl} /> }
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            }
          </div>
        </div>
      </section>
    )
  }
}

export default Guides